import * as React from "react";
const SvgSquareIcon = (props) => /* @__PURE__ */ React.createElement("svg", { width: 6, height: 5, viewBox: "0 0 6 5", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M5.5 0H0.5V5H5.5V0Z", fill: "currentColor" }));
export default SvgSquareIcon;
